// Pemilih produk untuk ujian prompt Partner — dikongsi test lab Partner (PartnerTestLab)
// dan "Test this version" admin (AdminPartnerReview). My Products pengguna sendiri +
// sampel System; data produk diambil dalam DUA bentuk (intelligenceJson inline ATAU payload).
import { useEffect, useMemo, useState } from 'react';
import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { loadLibraryPayload } from '../services/libraryPayloadService';

const LIB_FOLDER = 'product'; // sama dengan PipelineTestView / My Products

export const produkSedia = (it) => !!(it.hasIntelligence || it.hasScrapedData || it.intelligenceJson);
export const labelProduk = (it) => `${it.name || '(no name)'}${produkSedia(it) ? '' : ' — no data'}`;

/** Gambar produk untuk Vision (sama sumber dengan makmal admin: imageBase64 dahulu, kemudian imageUrl). */
export const gambarProduk = (p) => String(p?.imageBase64 || p?.imageUrl || '').trim();

/** Bentuk produk yang dihantar ke server. Gambar HANYA dihantar bila Vision hidup (server menyemaknya). */
export function produkUntukServer(p, gender, { vision = false } = {}) {
    return {
        name: p.name, link: p.link || '', price: p.price || '',
        originalPrice: p.originalPrice || '', discount: p.discount || '',
        gender: gender || null,
        intelligenceData: p.intelligenceData, scrapedData: p.scrapedData,
        ...(vision ? { gambar: gambarProduk(p) } : {}),
    };
}

export function useProdukLab(idAwal = '') {
    const [produkList, setProdukList] = useState({ sendiri: [], sampel: [], dimuat: false, ralat: '' });
    const [produkId, setProdukId] = useState(idAwal);
    const [produk, setProduk] = useState(null);

    useEffect(() => {
        let batal = false;
        (async () => {
            const email = auth.currentUser?.email;
            let sendiri = []; let sampel = []; let ralat = '';
            try {
                if (email) {
                    const s = await getDocs(query(collection(db, 'library', LIB_FOLDER, 'items'),
                        where('group', '==', 'own'), where('addedBy', '==', email), orderBy('number', 'asc')));
                    sendiri = s.docs.map((d) => ({ id: d.id, ...d.data() }));
                }
            } catch (e) { ralat = `Could not load your products: ${e.message}`; }
            try {
                const s = await getDocs(query(collection(db, 'library', LIB_FOLDER, 'items'),
                    where('group', '==', 'system'), orderBy('number', 'asc')));
                sampel = s.docs.map((d) => ({ id: d.id, ...d.data() }));
            } catch (e) { ralat = ralat || `Could not load sample products: ${e.message}`; }
            if (!batal) setProdukList({ sendiri, sampel, dimuat: true, ralat });
        })();
        return () => { batal = true; };
    }, []);

    const semuaProduk = useMemo(() => [...produkList.sendiri, ...produkList.sampel], [produkList]);

    useEffect(() => {
        if (!produkList.dimuat || !produkId) return undefined;
        const it = semuaProduk.find((x) => x.id === produkId);
        if (!it) return undefined;
        let batal = false;
        (async () => {
            let intel = it.intelligenceJson || null;
            let scraped = null;
            if (produkSedia(it) && (!intel || it.hasScrapedData)) {
                try {
                    const payload = await loadLibraryPayload(LIB_FOLDER, it.id);
                    intel = intel || payload?.intelligenceJson || null;
                    scraped = payload?.scrapedData || null;
                } catch (e) { console.warn('[ProdukLab] payload gagal:', e); }
            }
            if (!batal) setProduk({ ...it, intelligenceData: intel, scrapedData: scraped, hasData: !!(intel?.imageAnalysis || intel?.webResearch || scraped) });
        })();
        return () => { batal = true; };
    }, [produkId, produkList.dimuat, semuaProduk]);

    const produkSah = produk && produk.id === produkId ? produk : null;
    return { produkList, semuaProduk, produkId, setProdukId, produkSah };
}
